<template>
  <IconLucidePenTool />
</template>
